const url = process.env.VUE_APP_API_URL + "ending/reports"

export default {
  namespaced: true,

  state: {
    records: [],
    loading: false,
    cashInDetails: [],
    cashInDetailsLoading: false
  },
  mutations: {
    setRecords (state, val) {
      state.records = val
    },
    setRecordsLoading (state, val) {
      state.loading = val
    },
    setCashInDetails(state, val) {
      state.cashInDetails = val
    },
    setCashInDetailsLoading(state, val) {
      state.cashInDetailsLoading = val
    }
  },

  actions: {
    async getRecords({ commit, rootState }, data) {
      commit("setRecordsLoading", true)

      try {
        const response = await fetch(`${url}/cashin?${data}` , {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${rootState.userToken}`,
          }
        })

        const res = await response.json()
        
        if (!response.ok) {
          throw { response, res }
        } else {
          commit("setRecords", res.records)

          return res
        }
      } catch(error) {
        const errorStatus = error.response.status
        
        if (errorStatus==401) {
          commit("setError", "Unauthorized", { root: true })
        } else {
          commit("setRefreshError", "Submitted invalid data", { root: true })
        }
      } finally {
        commit("setRecordsLoading", false)
      }
    },

    async getCashInRequests({ commit, rootState }, data) {
      commit("setCashInDetailsLoading", true)

      try {
        const response = await fetch(`${url}/cashin_request?${data}` , {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${rootState.userToken}`,
          }
        })

        const res = await response.json()
        
        if (!response.ok) {
          throw { response, res }
        } else {
          commit("setCashInDetails", res.records)

          return res
        }
      } catch(error) {
        const errorStatus = error.response.status
        
        if (errorStatus==401) {
          commit("setError", "Unauthorized", { root: true })
        } else {
          commit("setRefreshError", "Submitted invalid data", { root: true })
        }
      } finally {
        commit("setCashInDetailsLoading", false)
      }
    },
  }
}